<template>
    <svg
        width="77"
        height="30"
        viewBox="0 0 77 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask
            id="mask0_17338_1352"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="77"
            height="30"
        >
            <path d="M76.05 0H0V29.9213H76.05V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_17338_1352)">
            <path
                d="M74.8028 27.2295H71.9645V20.2941C71.9645 19.2255 71.7628 18.4176 71.3591 17.8713C70.9633 17.325 70.3653 17.0521 69.5658 17.0521C68.7422 17.0521 68.0655 17.3609 67.535 17.9785C67.0044 18.5878 66.7394 19.3598 66.7394 20.2941V27.2295H63.8889V15.0689H66.7394V16.9213H66.7866C67.2301 16.2167 67.7842 15.6861 68.4495 15.33C69.1223 14.9657 69.8746 14.7837 70.7057 14.7837C72.0515 14.7837 73.069 15.2111 73.7578 16.0662C74.4546 16.9135 74.8028 18.1486 74.8028 19.7718V27.2295Z"
                fill="#212121"
            />
            <path
                d="M52.6099 25.8875L54.0232 24.0588C54.4824 24.4944 54.9732 24.8229 55.4958 25.0446C56.0186 25.266 56.5688 25.3771 57.1466 25.3771C57.8036 25.3771 58.3066 25.2503 58.6548 24.997C59.0112 24.7437 59.1892 24.3715 59.1892 23.8808C59.1892 23.4849 59.0349 23.1603 58.7261 22.9067C58.4173 22.6455 57.9226 22.4396 57.2415 22.2895C55.6979 21.9487 54.6093 21.4737 53.976 20.8641C53.3505 20.2468 53.0377 19.4827 53.0377 18.5721C53.0377 17.4322 53.469 16.5176 54.332 15.8287C55.2029 15.1319 56.3156 14.7837 57.6692 14.7837C58.4211 14.7837 59.1259 14.8944 59.7832 15.1162C60.4481 15.338 61.0538 15.6822 61.6002 16.1493L60.27 17.9189C59.8029 17.5704 59.3594 17.3172 58.9399 17.1588C58.5205 16.9926 58.0651 16.9095 57.5744 16.9095C56.9567 16.9095 56.4896 17.0324 56.1729 17.2778C55.8641 17.5153 55.7098 17.8438 55.7098 18.2633C55.7098 18.667 55.872 18.9797 56.1966 19.2014C56.5211 19.4154 57.1191 19.6213 57.9899 19.8191C59.2881 20.1042 60.2583 20.5595 60.8995 21.185C61.5485 21.8101 61.8732 22.618 61.8732 23.6074C61.8732 24.787 61.438 25.7331 60.567 26.446C59.704 27.1585 58.5519 27.5146 57.1112 27.5146C56.232 27.5146 55.4088 27.3799 54.6408 27.1109C53.8727 26.8336 53.196 26.4259 52.6099 25.8875Z"
                fill="#212121"
            />
            <path
                d="M50.9124 27.2298H48.0622V20.2587C48.0622 19.1502 47.8764 18.3385 47.5041 17.8241C47.1398 17.3093 46.5501 17.0521 45.7344 17.0521C45.0062 17.0521 44.4004 17.3728 43.9174 18.0139C43.4345 18.6551 43.1932 19.4389 43.1932 20.3654V27.2298H40.343V20.116C40.343 19.0947 40.1488 18.3306 39.7608 17.8241C39.3728 17.3093 38.7873 17.0521 38.0035 17.0521C37.2511 17.0521 36.6414 17.3569 36.1746 17.9667C35.7075 18.576 35.474 19.3838 35.474 20.389V27.2298H32.6235V15.0689H35.474V16.8741H35.5212C35.9328 16.2167 36.4712 15.7061 37.1365 15.3418C37.8014 14.9697 38.5379 14.7837 39.3453 14.7837C40.1926 14.7837 40.9169 14.9898 41.5187 15.4013C42.1202 15.805 42.5559 16.3632 42.8249 17.0757C43.292 16.3081 43.8659 15.7338 44.5469 15.3537C45.2358 14.9739 46.0275 14.7837 46.922 14.7837C48.2206 14.7837 49.2104 15.1954 49.8909 16.0189C50.572 16.8343 50.9124 18.0616 50.9124 19.7005V27.2298Z"
                fill="#212121"
            />
            <path
                d="M13.8014 23.6157C13.8014 23.6157 10.9875 29.6061 6.65923 29.3864C2.33205 29.1677 1.2559 21.547 10.7856 18.0127C10.7856 18.0127 14.7195 19.5382 13.8014 23.6157Z"
                fill="#6B6B6B"
            />
            <path
                d="M13.8014 23.6157C13.8014 23.6157 10.9875 29.6061 6.65923 29.3864C2.33205 29.1677 1.2559 21.547 10.7856 18.0127C10.7856 18.0127 14.7195 19.5382 13.8014 23.6157Z"
                fill="url(#paint0_radial_17338_1352)"
            />
            <path
                d="M13.8014 23.6157C13.8014 23.6157 10.9875 29.6061 6.65923 29.3864C2.33205 29.1677 1.2559 21.547 10.7856 18.0127C10.7856 18.0127 14.7195 19.5382 13.8014 23.6157Z"
                fill="url(#paint1_radial_17338_1352)"
            />
            <path
                d="M16.0858 23.7068C16.0858 23.7068 14.8388 29.4412 18.3486 29.3905C20.9951 29.3518 22.5859 25.59 20.268 19.9689C20.268 19.9689 18.2975 19.0315 16.0858 23.7068Z"
                fill="url(#paint2_radial_17338_1352)"
            />
            <path
                d="M16.0858 23.7068C16.0858 23.7068 14.8388 29.4412 18.3486 29.3905C20.9951 29.3518 22.5859 25.59 20.268 19.9689C20.268 19.9689 18.2975 19.0315 16.0858 23.7068Z"
                fill="url(#paint3_radial_17338_1352)"
            />
            <path
                d="M16.0858 23.7068C16.0858 23.7068 14.8388 29.4412 18.3486 29.3905C20.9951 29.3518 22.5859 25.59 20.268 19.9689C20.268 19.9689 18.2975 19.0315 16.0858 23.7068Z"
                fill="url(#paint4_radial_17338_1352)"
            />
            <path
                d="M16.0849 23.7038C16.0849 23.7038 17.2673 9.52931 23.4634 8.26033C27.2985 7.47497 29.0146 9.81369 29.0146 12.8032C29.0146 16.8826 24.7081 19.1191 21.9316 19.9431C18.8128 20.8687 17.1287 22.3304 16.0849 23.7038Z"
                fill="url(#paint5_radial_17338_1352)"
            />
            <path
                d="M16.0849 23.7038C16.0849 23.7038 17.2673 9.52931 23.4634 8.26033C27.2985 7.47497 29.0146 9.81369 29.0146 12.8032C29.0146 16.8826 24.7081 19.1191 21.9316 19.9431C18.8128 20.8687 17.1287 22.3304 16.0849 23.7038Z"
                fill="url(#paint6_radial_17338_1352)"
            />
            <path
                d="M16.0849 23.7038C16.0849 23.7038 17.2673 9.52931 23.4634 8.26033C27.2985 7.47497 29.0146 9.81369 29.0146 12.8032C29.0146 16.8826 24.7081 19.1191 21.9316 19.9431C18.8128 20.8687 17.1287 22.3304 16.0849 23.7038Z"
                fill="url(#paint7_radial_17338_1352)"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint8_linear_17338_1352)"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint9_radial_17338_1352)"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint10_radial_17338_1352)"
                fill-opacity="0.2"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint11_radial_17338_1352)"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint12_radial_17338_1352)"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint13_linear_17338_1352)"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint14_radial_17338_1352)"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint15_radial_17338_1352)"
                fill-opacity="0.2"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint16_radial_17338_1352)"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint17_radial_17338_1352)"
            />
            <path
                d="M13.8007 23.6182C13.8007 23.6182 14.4869 21.2242 8.00761 17.9043C1.52704 14.583 0.769844 10.5509 0.666766 8.22616C0.56365 5.90143 1.26282 3.90525 2.43885 2.77845C4.10465 1.18194 5.61792 0.897565 7.8293 1.08714C10.7689 1.33922 13.848 4.34911 15.385 9.05673C17.6191 15.8994 13.8007 23.6182 13.8007 23.6182Z"
                fill="url(#paint18_radial_17338_1352)"
            />
        </g>
        <defs>
            <radialGradient
                id="paint0_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(6.24212 33.4681) rotate(-71.1595) scale(16.7952 10.9961)"
            >
                <stop
                    offset="0.045"
                    stop-color="#FFC800"
                    stop-opacity="0.784314"
                />
                <stop offset="0.368273" stop-color="#98BD42" />
                <stop offset="0.587269" stop-color="#52B471" />
                <stop offset="0.767047" stop-color="#018D32" />
                <stop offset="0.878437" stop-color="#006523" />
            </radialGradient>
            <radialGradient
                id="paint1_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(6.24212 33.4681) rotate(-71.1595) scale(16.7952 10.9961)"
            >
                <stop offset="0.045" stop-color="#FFC800" />
                <stop offset="0.257166" stop-color="#B5BA1E" />
                <stop offset="0.368273" stop-color="#98BD42" />
                <stop offset="0.587269" stop-color="#52B471" />
                <stop offset="0.767047" stop-color="#018D32" />
                <stop offset="0.878437" stop-color="#006523" />
            </radialGradient>
            <radialGradient
                id="paint2_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(18.5921 29.9817) rotate(-106.858) scale(9.25848 8.6842)"
            >
                <stop stop-color="#FFC800" />
                <stop offset="0.286785" stop-color="#FFB657" />
                <stop offset="0.64175" stop-color="#FF5F3D" />
                <stop offset="1" stop-color="#B43014" />
            </radialGradient>
            <radialGradient
                id="paint3_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(18.6298 29.3909) rotate(-107.718) scale(9.06603 16.5249)"
            >
                <stop stop-color="#FFB657" />
                <stop offset="0.642929" stop-color="#FF835C" />
                <stop offset="0.960593" stop-color="#CA2134" />
            </radialGradient>
            <radialGradient
                id="paint4_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(18.9347 19.8921) rotate(94.5479) scale(10.4782 8.9117)"
            >
                <stop offset="0.706643" stop-color="#FFCD0F" stop-opacity="0" />
                <stop offset="1" stop-color="#FFCD0F" />
            </radialGradient>
            <radialGradient
                id="paint5_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(26.8075 5.59877) rotate(111.144) scale(16.5245 13.106)"
            >
                <stop offset="0.0661714" stop-color="#BD00FF" />
                <stop offset="1" stop-color="#FF5F3D" />
            </radialGradient>
            <radialGradient
                id="paint6_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(16.4969 24.0181) rotate(-72.3499) scale(11.1579 23.9681)"
            >
                <stop stop-color="#FF9E3D" />
                <stop offset="1" stop-color="#E23694" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint7_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(18.3229 24.1252) rotate(-91.116) scale(16.5429 19.7775)"
            >
                <stop offset="0.0661714" stop-color="#BD00FF" />
                <stop offset="1" stop-color="#FF5F3D" />
            </radialGradient>
            <linearGradient
                id="paint8_linear_17338_1352"
                x1="15.3011"
                y1="23.6179"
                x2="6.36184"
                y2="-0.0729859"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.38" stop-color="#0D91E1" />
                <stop offset="0.75" stop-color="#2FA2AA" />
            </linearGradient>
            <radialGradient
                id="paint9_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(11.2357 19.8307) rotate(-90.4465) scale(20.6753 36.6072)"
            >
                <stop stop-color="#3DCBFF" />
                <stop offset="1" stop-color="#0D91E1" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint10_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(11.8803 21.8179) rotate(-87.9282) scale(20.7957 36.0728)"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="#0D91E1" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint11_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(10.9135 -3.31409) rotate(89.3969) scale(25.5092 40.4686)"
            >
                <stop offset="0.015" stop-color="#0A308F" />
                <stop offset="0.205" stop-color="#2253CE" />
                <stop offset="1" stop-color="#2253CE" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint12_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(14.7264 25.523) rotate(-92.872) scale(16.0766 28.4649)"
            >
                <stop stop-color="#3DEE7B" />
                <stop offset="1" stop-color="#0D91E1" stop-opacity="0" />
            </radialGradient>
            <linearGradient
                id="paint13_linear_17338_1352"
                x1="15.3011"
                y1="23.6179"
                x2="6.36184"
                y2="-0.0729859"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.38" stop-color="#0D91E1" />
                <stop offset="0.75" stop-color="#2FA2AA" />
            </linearGradient>
            <radialGradient
                id="paint14_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(7.26189 1.62636) rotate(88.1795) scale(21.9746 38.9077)"
            >
                <stop stop-color="#3DCBFF" />
                <stop offset="1" stop-color="#0D91E1" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint15_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(6.88597 -0.360556) rotate(91.9349) scale(15.9044 27.5882)"
            >
                <stop stop-color="white" />
                <stop offset="1" stop-color="#0D91E1" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint16_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(7.7989 24.5564) rotate(-88.6872) scale(25.7829 40.9029)"
            >
                <stop offset="0.015" stop-color="#0A308F" />
                <stop offset="0.205" stop-color="#2253CE" />
                <stop offset="1" stop-color="#2253CE" stop-opacity="0" />
            </radialGradient>
            <radialGradient
                id="paint17_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(10.228 -1.09128) rotate(94.9679) scale(21.4386 34.5833)"
            >
                <stop stop-color="#3BD5FF" />
                <stop offset="0.417149" stop-color="#0D91E1" />
                <stop offset="0.743961" stop-color="#2764E7" />
                <stop offset="1" stop-color="#2052CB" />
            </radialGradient>
            <radialGradient
                id="paint18_radial_17338_1352"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(11.5042 -4.22701) rotate(91.8001) scale(18.8044 33.2947)"
            >
                <stop stop-color="#3DEEDF" stop-opacity="0.7" />
                <stop offset="1" stop-color="#0D91E1" stop-opacity="0" />
            </radialGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'Msn'
};
</script>
